// Reine Hilfsfunktionen für Rechnungen.js (Phase A Refactoring)
// 1:1 ausgelagert aus pages/Rechnungen.js
import { userStorage } from './userStorage';

// localStorage-Key: zuletzt benutzter Aufschlag je Preiskategorie merken
export const MARKUP_MEMORY_KEY = "rechnungen_markup_memory_v1";

export const loadMarkupMemory = () => {
  try {
    return JSON.parse(userStorage.getItem(MARKUP_MEMORY_KEY) || "{}") || {};
  } catch {
    return {};
  }
};

export const saveMarkupForCategory = (cat, markup) => {
  try {
    const mem = loadMarkupMemory();
    mem[cat] = markup;
    userStorage.setItem(MARKUP_MEMORY_KEY, JSON.stringify(mem));
  } catch { /* ignore */ }
};

export const markupForCategory = (cat, fallback = "15") => {
  const mem = loadMarkupMemory();
  const v = mem?.[cat];
  return (v === 0 || v) ? v.toString() : fallback;
};

// Rechnungen nach Quartal gruppieren (neuestes Quartal zuerst, innerhalb: neuestes Datum zuerst)
export const groupInvoicesByQuarter = (invs) => {
  const groups = {};
  (invs || []).forEach(inv => {
    if (!inv?.date) return;
    const d = new Date(inv.date);
    const y = d.getFullYear();
    const q = Math.floor(d.getMonth() / 3) + 1;
    const key = `${y}-Q${q}`;
    if (!groups[key]) groups[key] = { year: y, quarter: q, key, items: [] };
    groups[key].items.push(inv);
  });
  return Object.values(groups)
    .sort((a, b) => (b.year - a.year) || (b.quarter - a.quarter))
    .map(g => ({
      ...g,
      items: g.items.sort((a, b) => new Date(b.date) - new Date(a.date)),
      total: g.items.reduce((s, i) => s + (Number(i.total_brutto) || 0), 0),
    }));
};
